import { QueryKey } from '@tanstack/react-query'
import { AsyncJob } from './models'

export interface TaskTypeInfo {
  message: string
  href?: string
  suppressToast?: boolean
}

type TaskTypeResolver = (job: AsyncJob) => TaskTypeInfo
type InvalidateKeysFn = (job: AsyncJob) => QueryKey[]

const registry = new Map<string, TaskTypeResolver>()
const displayNames = new Map<string, string>()
const invalidateKeysRegistry = new Map<string, InvalidateKeysFn>()

export function registerTaskType(
  taskType: string,
  resolver: TaskTypeResolver,
  displayName?: string,
  invalidateKeys?: InvalidateKeysFn,
) {
  registry.set(taskType, resolver)
  if (displayName) {
    displayNames.set(taskType, displayName)
  }
  if (invalidateKeys) {
    invalidateKeysRegistry.set(taskType, invalidateKeys)
  }
}

export function resolveTaskType(job: AsyncJob): TaskTypeInfo {
  const resolver = registry.get(job.taskType)
  if (resolver) {
    return resolver(job)
  }
  return { message: job.label }
}

export function getInvalidateKeys(job: AsyncJob): QueryKey[] {
  const fn = invalidateKeysRegistry.get(job.taskType)
  return fn ? fn(job) : []
}

export function getTaskTypeDisplayName(taskType: string): string {
  return displayNames.get(taskType) ?? taskType.replace(/_/g, ' ')
}
